export enum EventBodyContentTypeEnum {
  HTML = 'HTML',
  Text = 'Text',
}
